import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import mantenedor from "@/services/mantenedor";
import auth from "@/auth/auth";
import router from "@/router";
import api from "@/config/axios";
import authDirecto, { userKey } from "@/auth/authDirecto";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rutaActual: "",
    snackbar: {
      mostrar: false,
      mensaje: "",
      color: "success",
      icon: ""
    },
    expireTimeout: null,
    expireDirTimeout: null,
    sessionCountdownInterval: null,
    directSessionCountdownInterval: null,
    sessionRemainingMs: 0,
    directSessionRemainingMs: 0,
    isUserIdle: false,
    drawer: true,
    dialogoMora: false,
    dialogoCampania: false,
    dialogoClave: false,
    userBits: {
      b_creditos_firmar: false,
      b_pago: false,
      b_socio: true,
      b_firma_habilitada: false
    },
    parametros: {
      mantencion: false,
      popup_clave: false,
      mostrar_contactanos: false,
      pago_directo: false
    },
    userCounter: {},
    setCounter: false,
    publicidadesDialogo: null,
    publicidadesSlider: null,
    informativos: null,
    dialogoPublicidades: false,
    secciones: null,
    dialogoFirma: false,
    dialogoDatosContacto: false,
    loadingState: true,
    tienePermiso: null,
    mantencionBits: {}

  },
  getters: {
    drawer: (state) => {
      return state.drawer;
    }
  },
  mutations: {
    cambiarRuta(state, ruta) {
      state.rutaActual = ruta;
    },
    SET_SNACKBAR(state, payload) {
      state.snackbar = payload;
    },
    CLOSE_SNACKBAR(state) {
      state.snackbar.mostrar = false;
    },
    SET_DRAWER(state, value) {
      state.drawer = value;
    },
    SET_DIALOGO_MORA(state, value) {
      state.dialogoMora = value;
    },
    SET_DIALOGO_CAMPANIA(state, value) {
      state.dialogoCampania = value;
    },
    SET_TIMEOUT(state, { remaining, direct }) {
      if (!direct) {
        state.expireTimeout = setTimeout(function () {
          let redirect = router.currentRoute.meta?.requiresAuth ? true : false;
          if (!auth.isAuthenticated()) {
            if (redirect)
              alert(
                "Su sesión ha expirado, si quiere seguir utilizando el portal ingrese nuevamente"
              );
            auth.cerrarSesion(redirect);
            return;
          }

          if (state.isUserIdle) {
            if (redirect)
              alert(
                "Su sesion expiro por inactividad, si quiere seguir utilizando el portal ingrese nuevamente"
              );
            auth.cerrarSesion(redirect);
            return;
          }

          auth
            .refreshAccessToken()
            .then((response) => {
              auth.updateUserAccessToken(response.data);
            })
            .catch(() => {
              if (redirect)
                alert(
                  "Su sesión ha expirado, si quiere seguir utilizando el portal ingrese nuevamente"
                );
              auth.cerrarSesion(redirect);
            });
        }, Math.max(remaining - 60000, 0));
      } else {
        state.expireDirTimeout = setTimeout(function () {
          let redirect = router.currentRoute.meta?.requiresDirectoAuth
            ? true
            : false;
          if (redirect)
            alert(
              "Su sesión ha expirado, si quiere seguir utilizando el portal ingrese nuevamente"
            );
          authDirecto.cerrarSesion(redirect);
        }, remaining);
      }
    },
    SET_SESSION_REMAINING(state, { remaining, direct }) {
      if (!direct) state.sessionRemainingMs = Math.max(remaining, 0);
      else state.directSessionRemainingMs = Math.max(remaining, 0);
    },
    START_SESSION_COUNTDOWN(state, { expiresAt, direct }) {
      const remainingField = direct
        ? "directSessionRemainingMs"
        : "sessionRemainingMs";
      const intervalField = direct
        ? "directSessionCountdownInterval"
        : "sessionCountdownInterval";

      if (state[intervalField]) clearInterval(state[intervalField]);

      state[remainingField] = Math.max(expiresAt - Date.now(), 0);
      state[intervalField] = setInterval(() => {
        const remaining = Math.max(expiresAt - Date.now(), 0);
        state[remainingField] = remaining;

        if (remaining <= 0 && state[intervalField]) {
          clearInterval(state[intervalField]);
          state[intervalField] = null;
        }
      }, 1000);
    },
    CLOSE_TIMEOUT(state, direct) {
      if (!direct) {
        clearTimeout(state.expireTimeout);
        if (state.sessionCountdownInterval) {
          clearInterval(state.sessionCountdownInterval);
          state.sessionCountdownInterval = null;
        }
        state.sessionRemainingMs = 0;
      } else {
        clearTimeout(state.expireDirTimeout);
        if (state.directSessionCountdownInterval) {
          clearInterval(state.directSessionCountdownInterval);
          state.directSessionCountdownInterval = null;
        }
        state.directSessionRemainingMs = 0;
      }
    },
    SET_BITS(state, value) {
      state.userBits = value;
    },
    SET_BITS_PRODUCTOS(state, value) {
      state.productsBits = value;
    },
    SET_BITS_MANTENCION(state, value) {
      state.mantencionBits = value;
    },
    SET_PARAMETROS(state, value) {
      state.parametros = value;
    },

    SET_COUNTERS(state, value) {
      state.userCounter = value;
      state.setCounter = true;
    },
    SET_INFORMATIVOS(state, value) {
      state.informativos = value;
    },
    SET_PUBLICIDADES(state, value) {
      if (value.dialog) state.publicidadesDialogo = value.data;
      else state.publicidadesSlider = value.data;
    },
    SET_DIALOGO_PUBLICIDADES(state, value) {
      state.dialogoPublicidades = value;
    },
    SET_DIALOGO_CLAVE(state, value) {
      state.dialogoClave = value;
    },
    CLEAN_PUBLICIDADES(state) {
      state.publicidadesDialogo = null;
      state.publicidadesSlider = null;
    },
    SET_SECCIONES(state, value) {
      state.secciones = value;
    },
    SET_DIALOGO_FIRMA(state, value) {
      state.dialogoFirma = value;
    },
    SET_DIALOGO_DATOS_CONTACTO(state, value) {
      state.dialogoDatosContacto = value;
    },
    SET_LOADING_STATE(state, value) {
      state.loadingState = value;
    },
    SET_USER_IDLE(state, value) {
      state.isUserIdle = value;
    },
    RESET_INITIAL(state) {
      state.dialogoMora = false;
      state.dialogoCampania = false;
      state.userBits = {
        b_creditos_firmar: false,
        b_pago: false,
        b_socio: true
      };
      state.productsBits = {};
      state.globalBits = {
        bit_mantencion: false
      };
      state.userCounter = {};
      state.setCounter = false;
      state.sessionRemainingMs = 0;
      state.directSessionRemainingMs = 0;
      state.isUserIdle = false;
      state.secciones = null;
      state.dialogoFirma = false;
      state.loadingState = false;
    }
  },
  actions: {
    mostrarAlerta({ commit }, payload) {
      let type = payload.color;
    
      if (payload.color === "success") {
        payload.icon = "mdi-check-circle-outline";
        // payload.color = "#24cad4";
      } else if (payload.color === "warning") {
        payload.icon = "mdi-alert-outline";
      } else if (payload.color === "error") {
        payload.icon = "mdi-alert-octagon-outline";
      } else if (payload.color === "info") {
        payload.icon = "mdi-alert-circle-outline";
      }
    
      commit("SET_SNACKBAR", {
        mostrar: true,
        type,              // 👈 tipo real
        color: payload.color, // 👈 hex
        mensaje: payload.mensaje,
        icon: payload.icon
      });
    },
    cerrarAlerta({ commit }) {
      commit("CLOSE_SNACKBAR");
    },

    switchDrawer({ commit }, value) {
      commit("SET_DRAWER", value);
    },
    mostrarDialogoMora({ commit }, value) {
      commit("SET_DIALOGO_MORA", value);
    },
    mostrarDialogoCampania({ commit }, value) {
      commit("SET_DIALOGO_CAMPANIA", value);
    },
    set_timeout(
      { commit },
      { direct = false, key = "userLoggedExpired" } = {}
    ) {
      let current = new Date().getTime();
      let expires = new Date(Cookies.get(key));
      let remaining = expires.getTime() - current;

      console.log(
        "Expiración " + (direct ? "Directo: " : "Portal: "),
        expires.getHours() +
        ":" +
        (expires.getMinutes() < 10
          ? "0" + expires.getMinutes()
          : expires.getMinutes())
      );
      commit("SET_SESSION_REMAINING", { remaining, direct });
      commit("START_SESSION_COUNTDOWN", {
        expiresAt: expires.getTime(),
        direct
      });
      commit("SET_TIMEOUT", { remaining, direct });
    },
    close_timeout({ commit }, direct = false) {
      commit("CLOSE_TIMEOUT", direct);
    },
    async updateBits({ commit }, value) {
      if (process.env.NODE_ENV === "development") {
        console.log("Actualizando bits");
      }
      // bits para saber si 
      await auth.userInfo(value.clien_s_id, 3).then((response) => {
        commit("SET_BITS_PRODUCTOS", response.data);
      }).catch((error) => console.error(error));

      await auth.bitsCliente(value).then((response) => {
        let bits = response.data;
        if (value.accion == 1) {
          commit("SET_BITS", bits);
          return
        }
        if (value.accion == 4) {
          commit("SET_BITS_MANTENCION", bits);
          return 
        }
      }).catch((error) => console.error(error));
    },

    async updateCounter({ commit }, value) {
      if (process.env.NODE_ENV === "development") {
        console.log("Actualizando contadores");
      }
      await auth
        .bitsCliente(value)
        .then((response) => {
          let counters = response.data;
          commit("SET_COUNTERS", counters);
        })
        .catch((error) => console.error(error));
    },
    mostrarDialogoPublicidad({ commit }, value) {
      commit("SET_DIALOGO_PUBLICIDADES", value);
    },
    mostrarDialogoClave({ commit }, value) {
      commit("SET_DIALOGO_CLAVE", value);
    },

    async setInformativos({ commit }) {
      await mantenedor
        .obtenerInformativos()
        .then((res) => {
          const data = res.data;
          // necesito que si muestre el informativo 1 si tiene tienePermis os 1 y los demas
          // pero si no tiene permisos 1 que muestre los restantes
          api
            .get(
              process.env.VUE_APP_API_URL +
              `portal-privado/cliente/validacion-asamblea-cliente/${
                auth.getUserLogged().id_cliente
              }`
            )
            .then((res) => {
              const tienePermiso = res.data;
              if (tienePermiso == 0) {
                const dataFiltrada = data.filter(
                  (i) => i._id != "6679c7b357f7254ae082a971"
                );
                commit("SET_INFORMATIVOS", dataFiltrada);
              }

              if (tienePermiso == 1) {
                const dataFiltrada = data.filter((i) => i._id);
                commit("SET_INFORMATIVOS", dataFiltrada);
              }
            });
        })
        .catch((error) => console.error(error));
    },
    async setPublicidades({ commit }, data) {
      await mantenedor
        .obtenerPublicidades(data.user, data.mostrar)
        .then((res) => {
          commit("SET_PUBLICIDADES", { data: res.data, dialog: data.mostrar });
          if (data.mostrar && res.data.length > 0)
            commit("SET_DIALOGO_PUBLICIDADES", true);
        })
        .catch((error) => console.error(error));
    },
    async setSecciones({ commit }) {
      await mantenedor
        .obtenerSecciones()
        .then((res) => {

          const secciones = [
            ...res.data
          ];
      
          commit("SET_SECCIONES", secciones);
        })
        .catch((error) => console.error(error));
    },

    async setParametros({ commit }) {
      commit("SET_LOADING_STATE", true);
      await mantenedor
        .obtenerParametros()
        .then((res) => {
          commit("SET_PARAMETROS", res.data);
          if (res.data.popup_clave) commit("SET_DIALOGO_CLAVE", true);
        })
        .catch((error) => console.error(error));
      commit("SET_LOADING_STATE", false);
    },

    mostrarDialogoFirma({ commit }, value) {
      commit("SET_DIALOGO_FIRMA", value);
    },
    mostrarDialogoDatosContacto({ commit }, value) {
      commit("SET_DIALOGO_DATOS_CONTACTO", value);
    },
    setLoadingState({ commit }, value) {
      commit("SET_LOADING_STATE", value);
    },
    setUserIdle({ commit }, value) {
      commit("SET_USER_IDLE", value);
    },
    limpiarPublicidades({ commit }) {
      commit("SET_DIALOGO_PUBLICIDADES", false);
      commit("CLEAN_PUBLICIDADES");
      commit("SET_INFORMATIVOS", null);
    },
    async cerrarSesion({ commit, dispatch }) {
      commit("RESET_INITIAL");
      await dispatch("limpiarPublicidades");
      dispatch("close_timeout");
    },
    async initData({ dispatch }) {
      try {
        let promises = [dispatch("setSecciones"), dispatch("setParametros")];
        if (authDirecto.isAuthenticated()) {
          dispatch("set_timeout", { direct: true, key: userKey + "Expired" });
        }
        if (auth.isAuthenticated()) {
          dispatch("set_timeout");
          
          promises.push(dispatch("updateBits", {
            accion: 1,
            clien_s_id: auth.getUserLogged().id_cliente,
          }));
          promises.push(dispatch("updateBits", {
            accion: 4,
            clien_s_id: auth.getUserLogged().id_cliente,
          }));
        }
        await Promise.all(promises);
      } catch (error) {
        dispatch("close_timeout");
        Cookies.remove("userLoggedExpired");
        Cookies.remove("userLoggedLR");
        await Vue.nextTick(); // Ensure the DOM is updated before navigating
        await router.push("/login");
      }
    }
  },
  modules: {}
});
